export default class CollectionToolbar extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            toolbar: "#collectionToolbar",
            toolbarPlaceholder: "#collectionToolbarPlaceholder",
        }

        this.toolbar = document.querySelector(this.selectors.toolbar);
        this.toolbarPlaceholder = document.querySelector(this.selectors.toolbarPlaceholder);
        this.toolbarDefaultPosition = this.toolbar.offsetTop;

        this.handleCheckScroll = this.handleCheckScroll.bind(this);
        this.productsCountEl = this.querySelector('[data-collection-products-count]')
        window.addEventListener("scroll", this.debounce(this.handleCheckScroll, 5));
    }


    connectedCallback() {
        this.updateTotalCountsListener();
    }

    disconnectedCallback() {
        this.removeUpdateTotalCountsListener();
    }

    updateTotalCountsListener() {
        document.addEventListener("updateTotalCounts", () => {
            this.updateTotalProductsCount();
        });
    }

    removeUpdateTotalCountsListener() {
        document.removeEventListener("updateTotalCounts", () => {
            this.updateTotalProductsCount();
        });
    }

    updateTotalProductsCount() {
        this.productsCountEl = this.querySelector('[data-collection-products-count]');
        if (this.productsCountEl) {
            this.productsCountEl.textContent = this.dataset.template === "search" ? this.dataset.searchResult : document.querySelectorAll('[data-loadmore-item]').length;
        }
    }

    debounce(func, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    }

    handleCheckScroll() {
        if (window.scrollY > this.toolbarDefaultPosition) {
            if (!this.toolbar.classList.contains("fixed")) {
                this.toolbar.classList.add("opacity-0");

                setTimeout(() => {
                    this.toolbar.classList.add("fixed");
                    this.toolbarPlaceholder.classList.add("visible");
                    this.toolbar.classList.remove("opacity-0");
                }, 200)
            }
        } else {
            if (this.toolbar.classList.contains("fixed")) {
                this.toolbar.classList.add("opacity-0");

                setTimeout(() => {
                    this.toolbar.classList.remove("fixed");
                    this.toolbarPlaceholder.classList.remove("visible");
                    this.toolbar.classList.remove("opacity-0");
                }, 200)
            }
        }
    }
}

customElements.define("collection-toolbar", CollectionToolbar);
